import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import { container } from '@/app/container';
import { NotifyRepositoryToken } from '../../di/tokens';
import type {
  ListEmailMessagesInput,
  RetryFailedEmailInput,
} from '../../domain/entities/notify.entity';

const EMAILS_QUERY_KEY = ['notify', 'emails'];

export function useNotifyEmails(input: ListEmailMessagesInput) {
  const repository = container.resolve(NotifyRepositoryToken);
  return useQuery({
    queryKey: [...EMAILS_QUERY_KEY, input.page ?? 1, input.perPage ?? 10],
    queryFn: () => repository.listEmails(input),
    staleTime: 1000 * 30,
    placeholderData: keepPreviousData,
  });
}

export function useRetryFailedEmail() {
  const repository = container.resolve(NotifyRepositoryToken);
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: string; body: RetryFailedEmailInput }) =>
      repository.retryEmail(vars.id, vars.body),
    onSuccess: () =>
      void queryClient.invalidateQueries({ queryKey: EMAILS_QUERY_KEY }),
  });
}
